import { gql } from '@apollo/client';

export const TEXT_SNIPPET_QUERY = gql`
  query GetTextSnippets {
    viewer {
      id
      company {
        id
        name
        reportsTextSnippet {
          nodes {
            id
            title
            content
            tags {
              nodes {
                id
                databaseId
                displayValue
              }
            }
          }
        }
      }
    }
  }
`;

export const CREATE_REPORT_TEXT_SNIPPET = gql`
  mutation CreateSnippet($input: ReportTextSnippetCreateInput!) {
    reportTextSnippetCreate(input: $input) {
      reportsTextSnippet {
        id
        title
        content
        tags {
          nodes {
            id
            databaseId
            displayValue
          }
        }
      }
      errors {
        message
      }
    }
  }
`;

export const UPDATE_REPORT_TEXT_SNIPPET = gql`
  mutation ReportTextSnippetUpdate($input: ReportTextSnippetUpdateInput!) {
    reportTextSnippetUpdate(input: $input) {
      reportsTextSnippet {
        id
        title
        content
        tags {
          nodes {
            id
            databaseId
            displayValue
          }
        }
      }
      errors {
        message
      }
    }
  }
`;

export const DELETE_REPORT_TEXT_SNIPPET = gql`
  mutation DeleteTextSnippets($input: ReportTextSnippetDeleteInput!) {
    reportTextSnippetDelete(input: $input) {
      deletedId
      errors {
        error
        message
      }
    }
  }
`;
